import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { CollapsibleListSection } from 'ui-components/components/collapsible-list/collapsible-list-section';
import { CollapsibleListSectionHeader } from 'ui-components/components/collapsible-list/collapsible-list-section-header';
import { CollapsibleListSectionContent } from 'ui-components/components/collapsible-list/collapsible-list-section-content';
import { noop } from 'ui-components/default-props/noop';
import FulfillmentPlanNotes from '../../../../fulfillment-plans/notes';
import { noteCountAndGiftText } from '../../../../services/order-note-service';
import { CollapsibleListSectionCollapsedContent } from 'ui-components/components/collapsible-list/collapsible-list-section-content/collapsed-content';

import { messages } from './messages';

import style from '../../orders-drawer.module.less';

/**
 * @deprecated
 * @param {object} props
 * @param {string} props.fulfillmentPlanId
 * @param {boolean} [props.open]
 * @param {(open: boolean) => void} [props.onClick]
 * @param {object[]} props.notes
 * @param {object} [props.dragHandleProps]
 * @returns {JSX.Element}
 */
const Notes = ({ open = false, onClick: onClickProp = noop, notes, fulfillmentPlanId, dragHandleProps }) => {
  const onClick = useCallback(() => onClickProp(open), [onClickProp, open]);
  return (
    <CollapsibleListSection open={open}>
      <CollapsibleListSectionHeader
        dragHandleProps={dragHandleProps}
        onClick={onClick}
        summaryData={noteCountAndGiftText(notes)}
        theme='white'
      >
        <FormattedMessage {...messages.notes} />
      </CollapsibleListSectionHeader>
      <CollapsibleListSectionContent>
        <div className={style['fulfillment-plan-notes-widget-wrapper']}>
          <FulfillmentPlanNotes fulfillmentPlanId={fulfillmentPlanId} />
        </div>
      </CollapsibleListSectionContent>
      <CollapsibleListSectionCollapsedContent className={style['collapsible-list-section-content']}>
        <div className={style['fulfillment-plan-notes-widget-wrapper']}>
          <FulfillmentPlanNotes fulfillmentPlanId={fulfillmentPlanId} hideUnpinned />
        </div>
      </CollapsibleListSectionCollapsedContent>
    </CollapsibleListSection>
  );
};

export default Notes;
